import Loading from '@cartwhl/ui/atoms/Loading';
import Text from '@cartwhl/ui/base/TextNew';

import { useStore } from '../dashboardStore';
import DashboardAppletGrid from './DashboardAppletGrid';

export default function DashboardAdmin() {
  const dashboardStore = useStore();
  const { adminApplets, userStoreLoading } = dashboardStore.state;

  if (userStoreLoading) {
    return (
      <div className="flex min-h-[240px] flex-col items-center justify-center gap-4">
        <Loading className="text-tertiary h-10 w-10" />
      </div>
    );
  }

  return (
    <DashboardAppletGrid
      title="Admin Apps"
      applets={adminApplets}
      emptyState={
        <Text token="14/medium" className="text-secondary text-pretty">
          No admin applets are available.
        </Text>
      }
    />
  );
}
